import {
  PDFGenerationStatus,
  asyncTaskToPDFGenerationStatusMap,
} from 'src/components/selfService/features/OrderHistory/OrderHistory.utils';
import { sdk } from 'src/utilities/sdk';
import { useAsyncDownloadTask } from 'src/utilities/useAsyncDownloadTask/useAsyncDownloadTask';

export interface UseGeneratePdfFile {
  generatePdf: () => void;
  downloadUrl: string;
  status: PDFGenerationStatus;
}

export interface UseGeneratePdfFileProps {
  corpId: string;
  orderId: string;
}

export const useGeneratePdfFile = ({
  corpId,
  orderId,
}: UseGeneratePdfFileProps): UseGeneratePdfFile => {
  const {
    status: asyncTaskStatus,
    startAsyncTask,
    downloadUrl,
  } = useAsyncDownloadTask();

  async function generatePdf() {
    await startAsyncTask(() => {
      return sdk.http.post(
        `/corp-admin/${corpId}/orders/${orderId}/receipt/start`,
        {}
      );
    });
  }

  return {
    generatePdf,
    downloadUrl,
    status: asyncTaskToPDFGenerationStatusMap.get(asyncTaskStatus),
  };
};
